import React, { MouseEvent, ReactNode, useState } from 'react';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import { DropdownMenuItem } from './DropdownMenuItem';
import ellipsisIcon from 'assets/icons/ellipsis-v.svg';
import './DropdownMenu.pcss';
import { useClickOutside } from '@mm/hooks';

export type MenuItem = {
  icon?: string | ReactNode;
  name: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => any;
  className?: string;
};

type Props = {
  menuItems: MenuItem[] | undefined;
  snowmanMenu?: boolean;
  menuButton?: (
    onMenuClick: (e: MouseEvent<HTMLButtonElement | HTMLDivElement>) => void,
  ) => ReactNode | Element[];
  className?: string;
  snowmanMenuHeight?: number;
};

type DefaultButtonProps = {
  handleShowMenuClick: (
    e: MouseEvent<HTMLButtonElement | HTMLDivElement>,
  ) => void;
  snowmanMenu?: boolean;
  snowmanMenuHeight?: number;
};

const DefaultButton = ({
  handleShowMenuClick,
  snowmanMenu,
  snowmanMenuHeight,
}: DefaultButtonProps) => (
  <Button
    className="dropdown-menu__button"
    onClick={handleShowMenuClick}
    onMouseDown={(e: MouseEvent<HTMLDivElement>) => {
      // Note: Need it to prevent propagation that causes issues in some scenarios
      e.preventDefault();
      e.stopPropagation();
    }}
  >
    {snowmanMenu ? (
      <img src={ellipsisIcon} alt="menu ellipsis" height={snowmanMenuHeight} />
    ) : (
      '...'
    )}
  </Button>
);

export const DropdownMenu = (props: Props) => {
  const { menuItems, snowmanMenu, className, menuButton, snowmanMenuHeight } =
    props;
  const [showButtonsDropdown, setShowButtonsDropdown] = useState(false);
  const classList = classnames('dropdown-wrapper', className);

  const handleClickOutside = () => setShowButtonsDropdown(false);

  const handleShowMenuClick = (
    e: MouseEvent<HTMLButtonElement | HTMLDivElement>,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    setShowButtonsDropdown(!showButtonsDropdown);
  };

  const clickOutsideRef = useClickOutside<HTMLDivElement>(handleClickOutside);

  return (
    <div ref={clickOutsideRef} className={classList}>
      {menuButton ? (
        menuButton(handleShowMenuClick)
      ) : (
        <DefaultButton
          handleShowMenuClick={handleShowMenuClick}
          snowmanMenu={snowmanMenu}
          snowmanMenuHeight={snowmanMenuHeight}
        />
      )}

      {menuItems && showButtonsDropdown && (
        <div className="dropdown-menu__items-container">
          <div className="dropdown-items-container__arrow" />

          {menuItems.map((i, idx) => (
            <DropdownMenuItem
              key={idx}
              className={i.className}
              icon={i.icon}
              name={i.name}
              onClick={e => {
                i.onClick(e);
                handleClickOutside();
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
